import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bde3a44"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alert alert-dismissible fade show",
  role: "alert"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Stay up to date", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "valuable updates", -1))
const _hoisted_4 = { class: "text-danger" }

import { axiosPost } from "@/util/axios";
import { useAuth0 } from "@auth0/auth0-vue";
import { onMounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsletterAlert',
  setup(__props) {

const auth0 = useAuth0();

const email = ref("");
const error = ref("");
const isVisible = ref(false);

onMounted(() => {
  if (!localStorage.getItem("newsletterAlertShown")) {
    isVisible.value = true;
  }
});

watch(
  () => auth0.user.value,
  (user) => {
    if (user?.email) {
      email.value = user.email;
    }
  },
  { immediate: true }
);

function subscribe() {
  if (email.value == "") {
    error.value = "Please enter an E-Mail adress";
    return;
  } else if (
    !email.value.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  ) {
    error.value = "Please enter a valid E-Mail adress";
    return;
  }
  axiosPost("/newsletter", {
    email: email.value,
  }).then(() => hideNewsletter());
}

function hideNewsletter() {
  localStorage.setItem("newsletterAlertShown", "true");
  isVisible.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_center = _resolveComponent("center")!

  return (isVisible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_center, null, {
          default: _withCtx(() => [
            _createTextVNode(" Welcome! "),
            _hoisted_2,
            _createTextVNode(" and receive "),
            _hoisted_3,
            _createTextVNode(" with our newsletter: "),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
            }, null, 512), [
              [_vModelText, email.value]
            ]),
            _createElementVNode("button", {
              onClick: subscribe,
              class: "btn btn-success mx-2"
            }, " Subscribe for free "),
            _createElementVNode("small", _hoisted_4, _toDisplayString(error.value), 1)
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close",
          "data-bs-dismiss": "alert",
          "aria-label": "Close",
          onClick: hideNewsletter
        })
      ]))
    : _createCommentVNode("", true)
}
}

})